import { useState } from 'react';
import { toast } from 'react-hot-toast';
import { supabase } from '../utils/supabase';

export const REGISTRATION_CHANGED_EVENT = 'wnf-registration-changed';

interface MutateArgs {
  playerId: string;
  gameId: string;
  action: 'register' | 'unregister';
  useToken?: boolean;
}

interface QuickRegisterResult {
  success: boolean;
  message?: string;
  registration_id?: string;
  status?: string;
  using_token?: boolean;
  injury_returned?: { return_streak: number } | null;
}

export const useQuickRegister = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);

  const mutate = async ({ playerId, gameId, action, useToken = false }: MutateArgs): Promise<QuickRegisterResult> => {
    setIsSubmitting(true);

    try {
      const { data, error } = await supabase.rpc('arcade_register', {
        p_player_id: playerId,
        p_game_id: gameId,
        p_action: action,
        p_use_token: useToken,
      });

      if (error) {
        toast.error(error.message);
        return { success: false, message: error.message };
      }

      const result = data as QuickRegisterResult;

      if (!result.success) {
        toast.error(result.message ?? 'Something went wrong');
        return result;
      }

      if (result.injury_returned) {
        toast.success(
          `Welcome back! Your streak is now ${result.injury_returned.return_streak} games.`,
          { duration: 5000, icon: '🩹' },
        );
      } else {
        toast.success(result.message ?? 'Done');
      }

      window.dispatchEvent(new Event(REGISTRATION_CHANGED_EVENT));

      return result;
    } finally {
      setIsSubmitting(false);
    }
  };

  return { mutate, isSubmitting };
};
